import React from "react";
import _includes from "lodash/includes";
import SummaryDetailsItem from "../../../Common/SummaryDetailsItem/SummaryDetailsItem";
import SummaryDetailsProps from "../../../../../types/SummaryDetailsProps";

const SummaryDetailsService = ({ caseData }: SummaryDetailsProps) => {
  return (
    <>
      <SummaryDetailsItem fieldPath={"reasonForDispute"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"serviceTitle"} caseData={caseData} />

      {caseData.reasonForDispute === "costEstimateExceeded" && (
        <>
          <SummaryDetailsItem fieldPath={"costEstimate"} caseData={caseData} fieldType={"money"} />
          <SummaryDetailsItem fieldPath={"costEstimateAdjustment"} caseData={caseData} />

          {_includes(["asap", "tooLate"], caseData.costEstimateAdjustment) && (
            <SummaryDetailsItem fieldPath={"costEstimateAdjustmentDate"} caseData={caseData} fieldType={"date"} />
          )}
        </>
      )}
      <SummaryDetailsItem fieldPath={"costReal"} caseData={caseData} fieldType={"money"} />

      {_includes(["hasDefects", "unfinishedWork"], caseData.reasonForDispute) && (
        <>
          <SummaryDetailsItem fieldPath={"defectsDescriptionClient"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"numberRepairAttempts"} caseData={caseData} />
        </>
      )}
    </>
  );
};

export default SummaryDetailsService;
